import { useCallback } from "react";
import { EMAILS_WERE_SENT } from "../../../lib/constants";
import { useOpenProgressModal } from "../../../lib/hooks/useOpenProgressModal";
import { useAppDispatch } from "../../../store";
import { setErrorMessage } from "../../../acions/actionsCreators/messageActions";
import MailingsService from "../../../services/mailings";

export const useResend = (
  reloadData: () => void,
  setIsSending: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  const dispatch = useAppDispatch();

  const { openModal } = useOpenProgressModal(
    "Resending Email",
    "Resending Email failed",
    reloadData,
    {
      customMsg: EMAILS_WERE_SENT,
    },
  );

  const resend = useCallback(
    async (id: string) => {
      try {
        setIsSending(true);

        const taskId: string = await MailingsService.resend(id);

        setIsSending(false);

        openModal(taskId);
      } catch (e: any) {
        dispatch(setErrorMessage(e.response.data.title, true));
        setIsSending(false);
      }
    },
    [dispatch, openModal, setIsSending],
  );

  return { resend };
};
